module.exports = __webpack_public_path__ + "img/logo.a16c7ebb.png";